import { SimpleGrid, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import VideoItem from './video-item'

const Videos = () => {
  return (
    <VStack gap={10}>
      <Text
        data-aos="fade-up"
        textStyle={'fastResultTitle'}
        mt={16}
        textTransform="uppercase"
        textAlign="center"
      >
        See it to believe it
      </Text>
      <SimpleGrid
        data-aos="fade-up"
        columns={{ base: 1, sm: 2, md: 2, lg: 2 }}
        gap={{
          base: 4,
          md: 10
        }}
        w={'100%'}
      >
        <VideoItem
          url="/videos/brands/cheongdam/bubble-test.mp4"
          title="bubble test"
        />
        <VideoItem
          url="/videos/brands/cheongdam/no-stains.mp4"
          title="no stain test"
        />
        <VideoItem
          url="/videos/brands/cheongdam/5-days-test.mp4"
          title="5 days tesT"
        />
        <VideoItem
          url="/videos/brands/cheongdam/scalp.mp4"
          title="scalp test"
        />
      </SimpleGrid>
    </VStack>
  )
}

export default Videos
